import { useState } from 'react';

import {
  CalendarMonth,
  NavigateBefore,
  NavigateNext,
} from '@mui/icons-material';
import {
  Button,
  IconButton,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Box, BoxProps } from '@mui/system';
import { DatePicker } from '@mui/x-date-pickers';
import {
  addWeeks,
  endOfWeek,
  format,
  isThisWeek,
  startOfWeek,
  subWeeks,
} from 'date-fns';

import { useMatchsPlannerContext } from './MatchsPlannerContext';

export const MatchsPlannerWeekController = ({ ...rest }: BoxProps) => {
  const { startDate, endDate, isLoading, changeDate } =
    useMatchsPlannerContext();

  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <Box {...rest}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography variant="h3" component="h3" sx={{ mb: 0, mr: 2 }}>
          {`Matchs du ${format(startDate, 'dd/MM/yy')} au ${format(
            endDate,
            'dd/MM/yy'
          )}`}
        </Typography>

        <Stack
          sx={{
            alignItems: 'center',
            justifyContent: 'center',
          }}
          spacing={2}
          direction="row"
        >
          <IconButton
            onClick={() => {
              changeDate({
                startDate: subWeeks(startDate, 1),
                endDate: subWeeks(endDate, 1),
              });
            }}
            color="primary"
            size="small"
            sx={{ background: 'white' }}
            disabled={isLoading}
          >
            <NavigateBefore />
          </IconButton>

          <IconButton
            onClick={() => {
              changeDate({
                startDate: addWeeks(startDate, 1),
                endDate: addWeeks(endDate, 1),
              });
            }}
            color="primary"
            size="small"
            sx={{ background: 'white' }}
            disabled={isLoading}
          >
            <NavigateNext />
          </IconButton>

          {!isThisWeek(startDate) && !isThisWeek(endDate) && (
            <Button
              variant="outlined"
              disabled={isLoading}
              size="small"
              onClick={() => {
                changeDate({
                  startDate: startOfWeek(new Date(), { weekStartsOn: 1 }),
                  endDate: endOfWeek(new Date(), { weekStartsOn: 1 }),
                });
              }}
            >
              Semaine courante
            </Button>
          )}

          <DatePicker
            label="Choix de la date"
            value={startDate}
            onClose={() => setIsOpen(false)}
            open={isOpen}
            onChange={(value) => {
              changeDate({
                startDate: value
                  ? startOfWeek(value, { weekStartsOn: 1 })
                  : undefined,
                endDate: value
                  ? endOfWeek(value, { weekStartsOn: 1 })
                  : undefined,
              });
              setIsOpen(false);
            }}
            slots={{
              textField: (params) => (
                <div>
                  <TextField
                    style={{ opacity: 0, width: 0, height: 0 }}
                    {...params}
                  />

                  <IconButton
                    color="primary"
                    onClick={() => {
                      setIsOpen(!isOpen);
                    }}
                  >
                    <CalendarMonth />
                  </IconButton>
                </div>
              ),
            }}
          />
        </Stack>
      </Box>
    </Box>
  );
};
